import type { BetaApplication } from "@canvaschool/contracts";

export const BETA_STATUS_LABEL = {
  PENDING: "대기",
  APPROVED: "승인됨",
  REJECTED: "거절됨",
} as const;

const BOM = String.fromCharCode(0xfeff);

const HEADER = [
  "신청일",
  "이름",
  "학교",
  "이메일",
  "남긴 말",
  "상태",
  "계정 아이디",
  "안내 메일 발송일",
];

/**
 * One CSV cell. A leading = + - @ (or tab/CR) would be read as a formula by
 * spreadsheets, so such cells get a leading apostrophe.
 */
export const csvCell = (value: string): string => {
  const safe = /^[=+\-@\t\r]/.test(value) ? `'${value}` : value;
  return /[",\r\n]/.test(safe) ? `"${safe.replace(/"/g, '""')}"` : safe;
};

/** UTF-8 BOM + comma-separated rows, so Excel opens Korean text correctly. */
export const buildBetaCsv = (items: readonly BetaApplication[]): string => {
  const rows = items.map((item) => [
    item.createdAt.slice(0, 10),
    item.name,
    item.schoolName,
    item.email,
    item.message,
    BETA_STATUS_LABEL[item.status],
    item.teacherLoginId ?? "",
    item.credentialsSentAt ? item.credentialsSentAt.slice(0, 10) : "",
  ]);
  const body = [HEADER, ...rows]
    .map((row) => row.map(csvCell).join(","))
    .join("\r\n");
  return `${BOM}${body}\r\n`;
};

export const betaCsvFileName = (now: Date = new Date()): string => {
  const pad = (value: number) => String(value).padStart(2, "0");
  return `beta-applications-${now.getFullYear()}${pad(now.getMonth() + 1)}${pad(
    now.getDate(),
  )}.csv`;
};

/** Hands the text to the browser as a file download. */
export const downloadCsv = (text: string, fileName: string) => {
  const url = URL.createObjectURL(
    new Blob([text], { type: "text/csv;charset=utf-8" }),
  );
  const anchor = document.createElement("a");
  anchor.href = url;
  anchor.download = fileName;
  document.body.appendChild(anchor);
  anchor.click();
  anchor.remove();
  URL.revokeObjectURL(url);
};
